import { W as WuiProgressBar$1, d as defineCustomElement$1 } from './progress-bar.js';

const WuiProgressBar = WuiProgressBar$1;
const defineCustomElement = defineCustomElement$1;

export { WuiProgressBar, defineCustomElement };

//# sourceMappingURL=wui-progress-bar.js.map